export default __webpack_public_path__ + "static/media/B-Washaya.08954e39.jpg";